<template>
  <div class="latest-article-container">
    <h3 v-if="categoryName != ''">{{ categoryName }}</h3>
    <p v-else class="article-title">{{ title }}</p>
    <div v-if="image != ''" class="inner-container">
      <!-- NOSONAR -->
      <a :href="buttonLink" :title="imageTitle">
        <img :alt="imageAlt" :src="image" />
      </a>
      <div class="description-container">
        <div class="col-sm-8">
          <h4>{{ imageTitle }}</h4>
        </div>
        <div class="col-sm-4">
          <div v-if="buttonText != ''" class="btn-container" @click="ctadatalayer()">
            <!-- NOSONAR -->
            <a :href="buttonLink" role="button" class="">
              <strong>{{ buttonText }}</strong>
            </a>
          </div>
        </div>
        <div style="clear: both"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'mixa-mag-latest-article',
  props: {
    categoryName: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
    image: {
      type: String,
      required: true,
    },
    imageTitle: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    buttonLink: {
      type: String,
      required: true,
    },
    imageAlt: {
      type: String,
      required: false,
    },
  },
  methods: {
    ctadatalayer() {
      dataLayer.push({
        event: 'uaevent',
        eventCategory: 'content page',
        eventAction: `select::${this.title}`,
        eventLabel: `${this.buttonText}::${this.buttonLink}`,
        ecommerce: 'undefined',
        event_name: 'body_button_click',
        module_name: this.title,
        cta_name: this.buttonText,
        link_url: this.buttonLink,
      });
    },
  },
};
</script>
